var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._v(" The page you are looking for cannot be found. Please return to the "),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" word validator ")]),_vm._v(". ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }